<riege-simple-page>
    <app-page-header [headline]="headline" [subline]="subline"> </app-page-header>

    <mat-tab-group
        class="riege-tabs tabgroup"
        mat-stretch-tabs="false"
        mat-align-tabs="start"
        color="accent"
        [selectedIndex]="selectedTab"
        (selectedIndexChange)="onTabChange($event)">
        <mat-tab label="{{ profileTab }}" labelClass="cy-tab-profile">
            <ng-template matTabContent>
                <h2 i18n="@@profile-info-headline" data-testid="cy-tabcontent-profile">Personal information</h2>
                <p i18n="@@profile-info-description"
                    >With this information you are logged into Azure. To change name, email address or phone number,
                    talk to your system administrator.</p
                >
                <br />

                <form
                    [formGroup]="profileForm"
                    (ngSubmit)="updateUserProfile()"
                    class="margin-xs--left"
                    data-testid="cy-profile-form-tabs">
                    <div class="row">
                        <div class="column is-one-fifth-tablet">
                            <riege-avatar-selector
                                #avatar
                                [editable]="true"
                                [avatar]="account ? account!.avatarURL : 'avatar_placeholder'"
                                (avatarChanged)="changeAvatar($event)">
                            </riege-avatar-selector>
                        </div>

                        <div class="column is-two-fifths-tablet">
                            <!-- Name -->
                            <div class="content__item">
                                <div class="content__label" i18n="@@label-name">Name</div>
                                <div class="content__body">{{ account?.name }}</div>
                            </div>
                            <!-- E-Mail -->
                            <div class="content__item">
                                <div class="content__label" i18n="@@label-email">Email</div>
                                <div class="content__body">{{ account?.email }}</div>
                            </div>
                            <!-- Phone Number -->
                            <div class="content__item">
                                <div class="content__label" i18n="@@label-phone">Phone</div>
                                <div class="content__body" [ngClass]="account?.phone ? '' : 'dimmed'"
                                    >{{ account?.phone ? account?.phone : nophone }}</div
                                >
                            </div>
                        </div>
                        <!-- Alternative E-Mails -->
                        <ng-container
                            *ngIf="account?.alternativeEmails && account?.alternativeEmails!.length > 0; else noAlternativeEmails">
                            <div class="column is-two-fifths-tablet">
                                <div class="content__item">
                                    <div class="content__label" i18n="@@label-email-alternatives"
                                        >Alternative emails</div
                                    >
                                    <div class="content__body" *ngFor="let email of account?.alternativeEmails">
                                        {{ email }} <br />
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-template #noAlternativeEmails>
                            <div class="column is-two-fifths-tablet">
                                <div class="content__item">
                                    <div class="content__label" i18n="@@label-email-alternatives"
                                        >Alternative emails</div
                                    >
                                    <div i18n="@@label-no-alternative-emails"
                                        >No alternative email addresses stored.</div
                                    >
                                </div>
                            </div>
                        </ng-template>
                    </div>

                    <button
                        class="riege-button"
                        type="submit"
                        mat-flat-button
                        color="primary"
                        i18n="@@button-label-save"
                        data-testid="cy-tab-profile-save-btn"
                        >Save</button
                    >
                </form>
            </ng-template>
        </mat-tab>

        <mat-tab label="{{ preferencesTab }}" labelClass="cy-tab-preferences">
            <ng-template matTabContent>
                <h2 i18n="@@profile-settings-headline" data-testid="cy-tabcontent-preferences">Language and region</h2>
                <p i18n="@@profile-settings-description"
                    >Settings for language and format apply to the web application and Scope client.</p
                >
                <br />

                <form [formGroup]="profileForm" novalidate (ngSubmit)="updateUserProfile()" class="margin-xs--left">
                    <div class="row">
                        <div class="column is-half-desktop">
                            <mat-form-field color="accent" class="full-width">
                                <mat-label for="preferredLanguage" i18n="@@input-label-language">Language</mat-label>
                                <mat-select
                                    formControlName="preferredLanguage"
                                    id="preferredLanguage"
                                    placeholder="Language"
                                    i18n-placeholder="@@input-label-language"
                                    data-testid="cy-select-language"
                                    required>
                                    <mat-option *ngFor="let language of sortedLanguages" [value]="language[0]">
                                        {{ language[1] }}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="profileForm.get('preferredLanguage')?.hasError('required')"
                                    i18n="@@input-error-preferredLanguage"
                                    >This field is required</mat-error
                                >
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="column is-half-desktop">
                            <mat-form-field color="accent" class="full-width">
                                <mat-label for="formatLocale" i18n="@@input-label-format"
                                    >Date, number and currency format</mat-label
                                >
                                <mat-select
                                    formControlName="formatLocale"
                                    id="formatLocale"
                                    (selectionChange)="changeCurrencyLocale($event.value)"
                                    placeholder="Date, number and currency format"
                                    i18n-placeholder="@@input-label-format"
                                    data-testid="cy-select-date"
                                    required>
                                    <mat-option *ngFor="let format of sortedFormatLocales" [value]="format[0]">
                                        {{ format[1] }}
                                    </mat-option>
                                </mat-select>
                                <mat-hint>
                                    <!-- use case - should be extracted to custom pipes -->
                                    {{ date |
                                    date:'short':undefined:(profileForm.get('formatLocale')?.value)?.toString() }} - {{
                                    num | number:undefined:(profileForm.get('formatLocale')?.value)?.toString() }} - {{
                                    currency() }}
                                </mat-hint>
                                <mat-error
                                    *ngIf="profileForm.get('formatLocale')?.hasError('required')"
                                    i18n="@@input-error-formatLocale"
                                    >This field is required</mat-error
                                >
                            </mat-form-field>
                        </div>
                    </div>

                    <div *ngIf="showHostRegions">
                        <div class="row">
                            <div class="column is-half-desktop">
                                <mat-form-field color="accent" class="full-width">
                                    <mat-label for="scopeRegion" i18n="@@input-label-region">Region</mat-label>
                                    <mat-select
                                        id="scopeRegion"
                                        [value]="selectedRegion"
                                        (selectionChange)="changeRegion($event.value)"
                                        data-testid="cy-select-region">
                                        <mat-option
                                            *ngFor="let region of regions"
                                            [value]="region[0]"
                                            [disabled]="!supportedRegions.includes(region[0])">
                                            {{ region[1] }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-hint i18n="@@select-hint-region"
                                        >Setting the region selects the nearest server and thus improves
                                        performance</mat-hint
                                    >
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="column is-half-desktop">
                            <button
                                class="riege-button"
                                type="submit"
                                mat-flat-button
                                color="primary"
                                i18n="@@button-label-save"
                                data-testid="cy-tab-preferences-save-btn"
                                >Save</button
                            >
                        </div>
                    </div>
                </form>
            </ng-template>
        </mat-tab>

        <mat-tab label="{{ signatureTab }}" labelClass="cy-tab-signature">
            <ng-template matTabContent>
                <h2 i18n="@@profile-signature-headline">Upload signature</h2>
                <p i18n="@@profile-signature-description"
                    >We recommend that you use a PNG image. Make sure that the background of the image is
                    transparent.</p
                >

                <span *ngIf="hasSignature$ | async, then image else dropzone"></span>
                <ng-template #image>
                    <div class="signature">
                        <img [src]="signature" aria-hidden="true" alt="" />
                        <button
                            mat-stroked-button
                            color="warn"
                            class="riege-button signature__btn-delete"
                            i18n="@@aria-label-delete-file"
                            (click)="deleteSignature()"
                            data-testid="cy-file-upload-delete"
                            >Remove file</button
                        >
                    </div>
                </ng-template>

                <ng-template #dropzone>
                    <riege-file-dropzone
                        class="half-width"
                        [directUpload]="true"
                        [multiple]="false"
                        [allowedTypes]="['jpg','jpeg','png']"
                        [allowedSize]="2048000"
                        [progress]="progress"
                        (fileChanged)="uploadUserSignature($event)">
                    </riege-file-dropzone>
                </ng-template>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</riege-simple-page>
